import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "coin_purchases",
        object: "coin_purchase",
        header: [
            { text: "ID", value: "id" },
            { text: "Nombre", value: "name" },
            { text: "Apellido", value: "last_name" },
            { text: "Monto Anterior", value: "previous_amount", sortable: false},
            { text: "Monto Adquirido", value: "amount_acquired", sortable: false},
            { text: "Monto Actual", value: "current_amount", sortable: false},
            { text: "Total", value: "total_in_pesos", sortable: false},
            { text: "Comision", value: "commission", sortable: false},
            { text: "Fecha", value: "date_approved", sortable: false},
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
